import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Projects.css";
import Sidebar from "../../components/Sidenav/sidenav.components";
import Loader from "../../components/Loader/loader.components";
import CarCard from "../../components/CarCard/Carcard";
import CreateCARModel from "../../components/CreateCARModel/CreateCARModel";
import { useLocation, useNavigate } from "react-router-dom";
import ToggleSwitch from "../../components/Toggle/Toggle";
import { Button, Card, Col, Row } from "react-bootstrap";
import SummaryReport from "../SummaryReport/SummaryReport";
import CarForm from "../CarForm";
import FileUploadModal from "../../components/FileUploadModal"
import UploadFileIcon from "../../assets/images/uploadFileIcon.svg";
import Closebtn from "../../assets/images/closebtn.svg";
import { getCarLookup, updateCorrectiveActionRequest, uploadShareFile } from "../../services/auth.api";
import { createSummaryReport, getSection_3_4, getSummaryreport } from "../../services/report.api";

import Toaster, { TosterVariant } from "../../components/Toaster/Toster";
import { isTokenValid } from "../../utils/authUtils";
import { CarService, ProjectService } from "../../services";
import { dateConversion } from "../../utils/formatDate";
import uploadIcon from "../../assets/images/upload-arrow.svg";
import backArrowOutline from "../../assets/images/back-arrow-outline.svg";
import { uploadProjectFiles, getFilesByFolderId } from "../../services/upload.api";
import SelectField from "../../components/CocSummaryReportSection/FscProductGroupList/SelectField";
import { getOptions } from "../../components/CocSummaryReportSection/FscProductGroupList/constants";
import moment from "moment";

import StatusBadges, { STATUSES} from "../../components/StatusBadges/StatusBadges";
import { FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';
import type { IconBaseProps } from 'react-icons';
import InfoTooltip from '../../components/InfoTooltip/InfoTooltip';
import ModalComponent from "../../components/Modal";

const InfoCircle = FaInfoCircle as React.ComponentType<IconBaseProps>;
const RevisionRequired = FaExclamationCircle  as React.FC;

const reportStatusColor: { [key: string]: string } = {
  "Draft": "red-dot",
  "SCS Review": "orange-dot",
  "Customer Review": "green-dot"
}

const ProjectStatusColor: { [key: string]: string } = {
  "--":"light-dark-dot",
  "Not Started": "light-dark-dot",
  "Planning": "dark-dot",
  "In Progress": "orange-dot",
  "Completed": "green-dot",
  "On Hold": "yellow-dot,",
  "Cancelled": "red-dot",
}

const fileUploadTypeOptions = ["Checklist", "FM Summary Report", "Supplemental Document", "Previous Year CAR"]

// Utility function to decode JWT token
const decodeJWT = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decodedData = JSON.parse(atob(base64));
  return decodedData;
};

const createNewSummaryReportPayload = (projectId: string, isFSCProject: boolean) => {
  const token = localStorage.getItem('access_token') || '';
  const decodedToken = decodeJWT(token);
  const programType = isFSCProject ? "CoC Summary Report" : "FM Summary Report";

  return {
      contactFirstName: decodedToken.firstName,
      contactSurname: decodedToken.lastName,
      email: decodedToken.email,
      project: projectId,
      programType,
      streetAddress: null,
      phoneCell: null,
      status: null,
      website: null,
      generalDescription: null,
      auditType: null,
      auditorName: null,
      descriptionOfChanges: null,
      fscstdMultipleSitesGroup: false,
      fscstdProjectCertification: false,
      fscstdReclaimedMaterial: false,
      fscstdControlledWoodSourcing: false,
      fscstdChainOfCustody: false,
      fscstdTrademarkUse: false,
      fscProductGroupList: false,
      pglfscAsSeperateRecord: false,
      fscProductFilename: null,
      pefcsfirwProductCategories: false,
      productListComparisonSCSPEFC: null,
      reclaimedMaterialsInformation: false,
      descriptionOfTheOrganizationSverifi: null,
      multiSiteGroupInformation: false,
      describeManagementSystem: null,
      describeManagementOfNonConformities: null,
      descriptionGroupMultisiteLevel: null,
      describeMaterialSourcing: null,
      siteRelationshipsAdditionRemovalP: null,
      fscaafData: false,
      fyStartDate: null,
      fptTurnoverLocalCurrency: null,
      fptLocalCurrencyUnit: null,
      totalRevenueUSD: null,
      fscDataRecentFY: false,
      fyEndDate: null,
      fptTurnoverUSD: null,
      totalRevenueLocalCurrency: null,
      fpttr: null,
      auditorCertificationReviewFSC: null,
      auditorCertificationReviewPEFC: null,
      auditorCertificationReviewSFI: null,
      auditorCertificationReviewOther: null,
      auditorCommentsFSC: null,
      auditorCommentsPEFC: null,
      auditorCommentsSFI: null,
      auditorCommentsOther: null,
      scsCertificationDecisionFSC: null,
      scsCertificationDecisionPEFC: null,
      scsCertificationDecisionSFI: null,
      scsCertificationDecisionOther: null,
      certificationDecisionsBy: null,
      centralOfficeAuditProgram: false,
      scsDecisionCommentsFSC: null,
      scsDecisionCommentsPEFC: null,
      scsDecisionCommentsSFI: null,
      scsDecisionCommentsOther: null,
      dateOfReportFinalization: null,
      certificateType: null,
      annualGrowthRate: null,
      allowableSizeLimit: null,
      opportunityCertificates: [],
      certifiedProducts: []
    };
}

const Projects = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const projectId = location.state?.ProjectId;

  const [lookupData, setLookupData] = useState<any>(null);

  const [fileList, setFileList] = useState<File[]>([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState(false);
  const [isCarChecked, setIsCarChecked] = useState<boolean>(false);
  const [projectDetails, setProjectDetails] = useState<any>({})
  const [openCARStatus, setOpenCARStatus] = useState<boolean>(false);
  const [CarDetails, setCarDetails] = useState<any[]>([]);
  const [selectedCar, setSelectedCar] = useState<any>(null);
  const [formType, setFormType] = useState<"new" | "edit">("new");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [carId, setCarId] = useState<any>(null);
  const [reportId, setReportId] = useState<any>(null);
  const [reportformData, setReportFormData] = useState<any>();
  const [section34Data, setSection34Data] = useState<any>();

  const [FolderId, setFolderId] = useState<any>(null);
  const [grade, setGrade] = useState<any>(null);
  const [shareFileOpportunityFolderId, setShareFileOpportunityFolderId] = useState<any>(null);

  const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility
  const [fileUploadType, setFileUploadType] = useState<string>("");
  const [toster, setToster] = useState<{ type: TosterVariant, show: boolean, message: string }>({
    type: "success",
    show: false,
    message: ""
  });
  const [isDocSuccess, setIsDocSuccess] = useState<boolean>(false);
  const [isDocFail, setIsDocFail] = useState<boolean>(false);
  const [certifiedSiteData, setCertifiedSiteData] = useState<{id: string; label: string, value: string}[]>([])
  const navigate = useNavigate();
  const isFSCProject = projectDetails.Program__r?.name === "FSC Chain of Custody";
  const isFMProject = projectDetails.Program__r?.name === "FSC Forest Management";
  const [reportName, setReportName] = useState<any>(null);

  const uploadSectionRef = useRef<HTMLInputElement>(null);
  const [projectStatus, setProjectStatus] = useState<string>(''); 
  const [revertedCARs, setRevertedCARs] = useState<any[]>([]);
  // Show Checklist not added modal pop up
  const [showChecklistMissingModal, setChecklistMissingModal] = useState(false);
   // Show Checklist messisng message
  const [showValidateSubmitProjectMsg, setValidateSubmitProjectMsg] = useState<string>("");
  // Show Confirmation modal before project submission
  const [showProjectSubmitConfirmModal, setProjectSubmitConfirmModal] = useState(false);

  const handleAddNewCar = () => {
    setIsModalVisible(true); // Show the modal when the user clicks "Add New CAR"
  };

  const handleHideModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  const allowedExtensions = ["pdf", "doc", "docx", "xls", "xlsx"];

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
   
    if (file) {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        setToster({...toster, type: "error", show: true, message: "The file type you uploaded is not supported, please upload a .pfd, .xls, .txt or .docx."})
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else if (file.size > 10 * 1024 * 1024 + 5) {
        setToster({ type: "error", show: true, message: `This file exceeds the max allowed file size. Please upload a file that does not exceed 10mb.` });
      } else {
        const renamedFile = new File([file], `${fileUploadType.replace(/ /g, "_")}.${fileExtension}`, { type: file.type });
        setFileList((prevFiles) => [...prevFiles, renamedFile]);
        try {
          setIsLoading(true);
          const response = await uploadProjectFiles(renamedFile, shareFileOpportunityFolderId);
          setIsDocSuccess(true);
         
          // Create a new summary report on document upload if file is FM Summary Report
          if(fileUploadType  === 'FM Summary Report'){
            const summaryReportPayload = createNewSummaryReportPayload(projectId, isFSCProject);
            await createSummaryReport(summaryReportPayload);
          }
          
          setIsLoading(false);

          setToster({...toster, type: "success", show: true, message: "File uploaded successfully."})
          setTimeout(() => {
            setIsDocSuccess(false);
          }, 4000)
        } catch (error) {
          setIsLoading(false);
          setIsDocFail(true);
          setFileList((prevFiles) => prevFiles.filter((f) => f !== renamedFile));
          setToster({...toster, type: "error", show: true, message: "It seems there was an error on our end preventing your upload from completing, please try uploading the document again."})
          setTimeout(() => {
            setIsDocFail(false);
          }, 4000)
        }
      }
    }
  };

  const handleCarClick = async (car: any) => {
    setSelectedCar(car);
    setCarId(car.id);
    const draftFolderUrl = car.ShareFile_Draft_Folder__c;
    const folderPath = draftFolderUrl?.split("/").pop();
    setFolderId(folderPath);
    await CarService.fetchCARSiteIssues(projectDetails?.inspire1__Opportunity1__r?.id, projectDetails?.inspire1__Opportunity1__r?.Record_Type_Name__c, projectDetails?.Program__r.name)
    .then(response => {
      console.log(response.isSuccess)
      const filteredSiteIssues: any = [];
       if (response) {
        response.customerSites.forEach((element: any) => {
          filteredSiteIssues.push({ id: element?.CustomerSite__r?.Name, label: element?.CustomerSite__r?.Name, value: element?.CustomerSite__r?.Name });
        });
       };
       console.log(filteredSiteIssues)

       setCertifiedSiteData(filteredSiteIssues);
    })
    .catch(error => {
      console.log(error)
    })
    if (!isTokenValid()) {
      navigate('/logout'); 
      return; 
    }
    setDrawerOpen(true);
    setFormType("edit");
  };

  const fileRemove = (file: File) => {
    const updatedList = fileList.filter((item) => item !== file);
    setFileList(updatedList);
  };


  const handleAddCar = (newCar: any) => {
    console.log("newCar in handle",newCar);

    setCarDetails((prevDetails) => {
      if (formType === "edit") {
        return prevDetails.map((car) =>
          car.Id === newCar.Id ? { ...car, ...newCar } : car
        );
      } else {
        console.log("newCar in return",newCar);
        return [...prevDetails, newCar];
      }
    });
  };



const handleCreateCar = async (grade: string) => {
  setIsLoading(true);

  const newCar = {
    scheme: "FSC Chain of Custody",
    issueDate: new Date().toISOString().split("T")[0],
    grade, 
    primaryStandardReference: "",
    status: "Draft",
    section: "",
    siteIssuedTo: "",
    observationDescriptionOfNonconformance: "",
    nonconformanceEvidence: "",
    otherApplicableReferences: "",
  };
  
  try {
    const response = await updateCorrectiveActionRequest(projectId, newCar);
    console.log("Response from empty newCar:", response);

    if (response.isSuccess) {
      setIsLoading(false);
      console.log("CAR created successfully with empty data");
      const carData = response.response.data.CARData[0];
      const certifiedSites = response.response.data.CertifiedSites || [];
      setCarId(carData.CarId);
      setSelectedCar({id: carData.CarId, Name: carData.NAME});
      setCertifiedSiteData(certifiedSites.map((site: any) => ({ id: site.CertifiedSiteId, label: site.CustomerSiteName, value: site.CustomerSiteName })))
      setGrade(grade);
      setFormType("edit");
      fetchPojectInfo();
      if (!isTokenValid()) {
        navigate('/logout'); 
        return; 
      }
      setDrawerOpen(true);
    } else {
      setIsLoading(false);
      console.log("Error creating CAR");
    }
  } catch (error) {
    setIsLoading(false);
    console.log("Error:", error);
  }
};


const handleSummaryReport = async () => {
  setIsLoading(true);
  
  try {
    if (projectDetails.Summary_Reports__r === null) {
      const newAuditReport = createNewSummaryReportPayload(projectId, isFSCProject);
      const response = await createSummaryReport(newAuditReport);
      console.log("Response from empty newCar:", response);

      if (response.isSuccess) {
        console.log("Summary Report Created with empty data");
      
        // Extract ID from the message
        const idMatch = response.message.match(/ID:\s*(\w+)/);
        const reportId = idMatch ? idMatch[1] : null;
        // summary report id getting summary report name when create summary report
        const createdReportName = response.id;
        setReportName(createdReportName)
      
        setReportId(reportId);
      
        fetchPojectInfo();
        getSummaryReport(reportId)
      
        if (!isTokenValid()) {
          navigate('/logout');
          return;
        }
      
        setIsDrawerOpen(true)
      } else {
        console.log("Error creating Summary Report");
      }
    }
  } catch (error) {
    console.log("Error:", error);
  } finally {
    setIsLoading(false);
  }
};




// Delete CAR functionality

const [showDeleteCARToster, setShowDeleteCARToster] = useState<boolean>(false);
const [deleteCARTosterInfo, setDeleteCARTosterInfo] = useState<{type: "success" | "error"  | "warning", message: string}>({type: "success", message: ""});
const handleDeleteCar = (carId: string) => {
  // Sample Testing code.....

  // setIsLoading(true);
  // console.log(CarDetails.filter((car) => String(car.Id) === String(carId)))
  // setCarDetails((pre) => pre.filter((car: any) => String(car.Id) !== String(carId)))
  // setIsLoading(false)
  // setDeleteCARTosterInfo({type: "success", message: "CAR 2024-XXXXXXX-01 was removed from the project"});
  // setShowDeleteCARToster(true);

  CarService.deleteCAR(carId)
  .then((response: any) => {
    if (response.isSuccess) {
      setCarDetails((pre) => pre.filter(car => car.id !== carId))
      setIsLoading(false)
      setDeleteCARTosterInfo({type: "success", message: `CAR ${carId} was removed from the project`})
      fetchPojectInfo();
      setShowDeleteCARToster(true);

    }
  })
  .catch((error: any) => {
    console.log('error:', error)
    setIsLoading(false)
    setDeleteCARTosterInfo({type: "error", message: `CAR ${carId} was not removed from the project`})
    setShowDeleteCARToster(true);

   })
  setDrawerOpen(false);

}

const fetchPojectInfo = () => {
  if (projectId) {
    setIsLoading(true);
    ProjectService.getProject(projectId)
    .then(response => {
      setProjectDetails(response.project);
      setShareFileOpportunityFolderId(response.shareFileOpportunityFolderId);
      const openCARs = response.project.Corrective_Action_Requests__r?.records.some((car: any) => car.Status__c !== "Closed");
      setOpenCARStatus(openCARs);
      setCarDetails(response.project.Corrective_Action_Requests__r?.records);

      // Display Project statuses 
      const revertedDraftCARDetails = response.project.Corrective_Action_Requests__r?.records.filter((car: any) => car.Reverted_Draft__c === "true");
      setRevertedCARs(revertedDraftCARDetails);
     
      let isReportAttached = (response.project.Summary_Reports__r?.records?.length > 0) ? true : false;
      let isReportSubmitted = false;
      if(isReportAttached){
         isReportSubmitted = response.project.Summary_Reports__r?.records[0]?.Status__c !== "Draft";
      }

      // Display Draft status
      setProjectStatus(STATUSES.DRAFT);
      if(revertedDraftCARDetails?.length > 0){ // If any CAR is moved back into “DRAFT” status after the initial submission then display status as Revision Required
        setProjectStatus(STATUSES.REVISION_REQUIRED);
      }else if(isReportSubmitted){ // If summary report is submitted then display status as a Technical Review
        setProjectStatus(STATUSES.TECHNICAL_REVIEW);
      }

      setIsLoading(false);
    })
    .catch(error =>{
      setDeleteCARTosterInfo({type: "error", message: `Project Id with ${projectId} not found.`});
      setShowDeleteCARToster(true);
      setIsLoading(false);
    })
  } else {
    setDeleteCARTosterInfo({type: "error", message: `Invalid Project Id.`});
    setShowDeleteCARToster(true);
  }
}

// Toggle CARs for show all or show only closed

const handleCarToggle = () => {
  setIsCarChecked(!isCarChecked);
  if (!isCarChecked) {
    const filteredCarDetails = projectDetails.Corrective_Action_Requests__r?.records.filter((car: any) => car.Status__c !== "Closed")
    setCarDetails(filteredCarDetails);
  } else {
    setCarDetails(projectDetails.Corrective_Action_Requests__r?.records);
  }
};

// Submit the project to update status of project.

const handleSubmitProject = () => {
  if (projectId) {

    // Check checklist file is uploaded or not 

    const isChecklistExist = fileList.some(file => {
      const baseName = file.name.split('.').slice(0, -1).join('.');
      return baseName.toLocaleLowerCase() === 'checklist';
    });

    // Check FM report file is uploaded or not 
    const isAttachedFM = fileList.some(file => {
      const baseName = file.name.split('.').slice(0, -1).join('.');
      return baseName.toLocaleLowerCase() === 'fm_summary_report';
    });

    let isReportAttached = (projectDetails.Summary_Reports__r?.records?.length > 0) ? true : false;

    setChecklistMissingModal(false);
    let showValidationPrompt = false;

    if(isFSCProject){  // Validate COC Project - Checklist and Report is atttached or not
      if(isChecklistExist === false && isReportAttached === false){
        setChecklistMissingModal(true);
        showValidationPrompt = true;
        setValidateSubmitProjectMsg("Please add the required Checklist and CoC Summary Report before submitting this project.");
      }else if(isChecklistExist === false){
        setChecklistMissingModal(true);
        showValidationPrompt = true;
        setValidateSubmitProjectMsg("Please add the required Checklist before submitting this project.");
      }else if(isReportAttached === false){
         setChecklistMissingModal(true);
         showValidationPrompt = true;
         setValidateSubmitProjectMsg("Please add the required CoC Summary Report before submitting this project.");
      }
    }else if(isFMProject){  // Validate FM Project - Checklist and FM is attached or not
      if(isChecklistExist === false && isReportAttached === false){
        setChecklistMissingModal(true);
        showValidationPrompt = true;
        setValidateSubmitProjectMsg("Please add the required Checklist and FM Summary Report before submitting this project.");
      }else if(isChecklistExist === false){
        setChecklistMissingModal(true);
        showValidationPrompt = true;
        setValidateSubmitProjectMsg("Please add the required Checklist before submitting this project.");
      }else if(isReportAttached === false){
         setChecklistMissingModal(true);
         showValidationPrompt = true;
         setValidateSubmitProjectMsg("Please add the required FM Summary Report before submitting this project.");
      }
    }

    if(showValidationPrompt){
       return;
    }else{
      setChecklistMissingModal(false);
    }

    // Display Project submission confirmation prompt
    setProjectSubmitConfirmModal(true);
  } else {
    setDeleteCARTosterInfo({type: "error", message: `Invalid Project Id.`});
    setShowDeleteCARToster(true);
  }
}

// handle close CAR from Drawer

const handleAddOrCloseCARFrom = () => {
  fetchPojectInfo();
}

  const fetchShareFileOpportunityFolderId = async () => {
    try {
      const response = await getFilesByFolderId(shareFileOpportunityFolderId);
  
      // Access the `files` array correctly from the response object
      if (response && Array.isArray(response.files)) {
        setFileList(response.files.map((name: string) => ({ name, size: "Uploaded" })));; // Update state with the `files` array
      } else {
        console.error("Invalid response structure for existing files", response);
        setFileList([]); // fallback to empty array
      }
    } catch (err) {
      console.error("Failed to fetch existing files:", err);
      setFileList([]); // fallback to empty array in case of error
    }
  }

  useEffect(() => {
    setIsLoading(true);
    const fetchLookupData = async () => {
      try {
        const data = await getCarLookup(projectId);
        if (data) {
          localStorage.setItem('lookupData', JSON.stringify(data));
          setLookupData(data); 
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchLookupData();
    fetchPojectInfo();
  }, []);

  useEffect(() => {
    if (shareFileOpportunityFolderId) {
      fetchShareFileOpportunityFolderId();
    }
  }, [shareFileOpportunityFolderId]);


  const getSummaryReport = async (SummaryReportId:any) => {
    setIsLoading(true);  
    
    try {
      const response = await getSummaryreport(SummaryReportId);
      console.log("Response from empty newCar:", response);
  
      const section3_4Response = await getSection_3_4(projectDetails.inspire1__Opportunity1__r.id, projectDetails.inspire1__Opportunity1__r.Record_Type_Name__c);
      console.log("Section 3 & 4 Response:", section3_4Response);
    
      if (response.isSuccess && section3_4Response.isSuccess) {
        setIsLoading(false);      
        setReportId(SummaryReportId);
        setReportFormData(response.summaryReport);
        // setSection34Data(section3_4Response.opportunityCertificates);
       
        setSection34Data(section3_4Response);
        setReportName(response.summaryReport.Name)

        if (!isTokenValid()) {
          navigate('/logout');
          return;
        }
        setIsDrawerOpen(true)
      } else {
        setIsLoading(false);
        console.log("Error getting Report");
      }
      
    } catch (error) {
      setIsLoading(false);
      console.log("Error:", error);
    }
  };


  const handleFMReportCardClick = () => {
    setFileUploadType("FM Summary Report");
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }

  const summaryReportDueDate = useMemo(() => {
    const reviewRecieveTask = projectDetails?.inspire1__Inspire_Tasks__r?.records?.find(({Name}: {Name: string}) => Name === "Receive Report")
    const date = reviewRecieveTask?.inspire1__Finish_Date_Only__c || null;
    return moment(date).isValid() ? moment(date).format("MMM DD YYYY") : "--"
  }, [projectDetails])

  const handleChecklistSubmit = () => {
    setChecklistMissingModal(false);
    // Check need to open upload control or not is summary report is pending to submit then do not open
     let showUploadControl = true;
     if(isFSCProject || isFMProject){ 
      let isReportAttached = (projectDetails.Summary_Reports__r?.records?.length > 0) ? true : false;
      if(!isReportAttached){
         showUploadControl = false;
      }
    }
    if (showUploadControl) {
      if (fileInputRef.current) {
        setFileUploadType("Checklist");
        fileInputRef.current.click();
      }

      if (uploadSectionRef.current) {
        setTimeout(() => {
          uploadSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 1000)
      }
    }
  }

  const handleProjectSubmitAfterConfirm = () => {
    setProjectSubmitConfirmModal(false);
    setIsLoading(true);
    ProjectService.updateProject(projectId)
    .then(response => {
      setIsLoading(false);
      setDeleteCARTosterInfo({type: "success", message: `Project Id with ${projectId} successfuly submited.`})
     fetchPojectInfo();
    })
    .catch(error =>{
      setDeleteCARTosterInfo({type: "error", message: `Project Id with ${projectId} not found.`});
      setShowDeleteCARToster(true);
      setIsLoading(false);
    })
    setIsLoading(false);
  }


  return (
    <>
      <Sidebar />

      <main className="container-fluid dashboard-bg">
        <div className="main main-app p-3 p-lg-4">
           <div className="d-flex justify-content-between align-items-center pt-2 custom-header__account_name">{projectDetails.inspire1__Account__r?.Name}</div>
          <div className="d-flex justify-content-between align-items-center pt-2">
            <Row className="w-100">
              <Col md={10}>
                <div className="d-flex flex-wrap align-items-center">
                  <div className="d-flex flex-wrap align-items-center gap-3" style={{ gap: '0.5rem', flexGrow: 1 }}>
                   <div
                      style={{
                        fontWeight: 'bold',
                        fontSize: '1.2rem',
                        wordBreak: 'break-word',
                        flexShrink: 1,
                        minWidth: 0,
                      }}
                    >
                    {projectDetails.Name}
                    </div>
                    <div
                      className="d-flex align-items-center gap-2"
                      style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                    >
                       {
                          projectStatus === STATUSES.DRAFT && <><StatusBadges status="draft" />
                            <button
                              type="button"
                              className="btn btn-primary bt-submit"
                              onClick={handleSubmitProject}
                              style={{ fontSize: "10px" }}
                            >
                              Submit for Review
                            </button></>
                        }
                        {
                          projectStatus === STATUSES.TECHNICAL_REVIEW && <><StatusBadges status="technical-review" /></>
                        }
                        {
                          projectStatus === STATUSES.REVISION_REQUIRED && <>
                            <InfoTooltip tooltipClassName="bg-danger text-white wide-tooltip" placement="right" content="There are CARs that require your review. Please make the requested changes and submit each CAR upon completion.">
                              <StatusBadges status="revision-required" />
                            </InfoTooltip></>
                        }
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={2}><div className="back-to" onClick={() => navigate("/dashboard")}><img src={backArrowOutline} alt="Upload Icon" className="save-icon" /><div>Go Back To Dashboard</div></div></Col>
            </Row>
          </div>
          {!isLoading ? "" : <Loader/>}
          <hr
            style={{ borderColor: "#919191", borderWidth: "1px" }}
            className="my-2"
          />
          <div className="row g-3">
            <div className="col-7 g-3">
              <div className="card card-table p-10">
                <p className="p-0" style={{ fontSize: "16px" }}>
                  <strong>Audit Details</strong>
                </p>
                <div className="card-body px-0">
                  <div className="row">
                    <div className="col-5">
                      <table className="table table-borderless adid-details-table">
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: 800 }}>Scheme</td>
                            <td>{projectDetails.Program__r?.name}</td>
                            </tr>
                          <tr>
                            <td style={{ fontWeight: 800 }}>Status</td>
                            <td className="d-flex align-items-center">
                              <div className={`${ProjectStatusColor[projectDetails.inspire1__Project_Status__c ? projectDetails.inspire1__Project_Status__c : "--"]}`}></div> &nbsp; {projectDetails.inspire1__Project_Status__c ? projectDetails.inspire1__Project_Status__c : "--"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 800 }}>Open CARs</td>
                            <td>{openCARStatus ? "Yes" : "No"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-7">
                      <table className="table table-borderless adid-details-table">
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: 800 }}>
                              Certificate Expiration Date
                            </td>
                            <td>
                              <i className="bi bi-calendar-event" style={{fontSize:"12px"}}></i> &nbsp;{projectDetails.inspire1__Opportunity1__r?.Certificate_Expiration_Date__c ? dateConversion(projectDetails.inspire1__Opportunity1__r?.Certificate_Expiration_Date__c, "MMMM DD YYYY") : "--"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 800 }}>Report Due Date</td>
                            <td style={{fontSize:"12px"}}>
                              <i className="bi bi-calendar-event" style={{fontSize:"12px"}}></i>  &nbsp;{projectDetails?.inspire1__Inspire_Tasks__r?.records?.[0]?.inspire1__Finish_Date_Only__c ? dateConversion(projectDetails.inspire1__Inspire_Tasks__r.records[0].inspire1__Finish_Date_Only__c, "MMMM DD YYYY") : "--"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 800 }}>
                              Scheduled Audit Date
                            </td>
                            <td>
                              <i className="bi bi-calendar-event" style={{fontSize:"12px"}}></i> &nbsp;{projectDetails.inspire1__Opportunity1__r?.Audit_Scheduled_Date__c ? dateConversion(projectDetails.inspire1__Opportunity1__r?.Audit_Scheduled_Date__c, "MMMM DD YYYY") : "--"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div className="card card-table p-10">
                <p className="p-0 m-0" style={{ fontSize: "16px" }}>
                  <strong>1.Reports</strong>
                </p>
                <span style={{ fontSize: "9px" }}>
                  Please select the summary report type you&apos;ll be creating.
                </span>
                <div
                  className="card-body px-0"
                >
                  <div className="row">
                    {!!projectDetails.Summary_Reports__r?.records && !isFMProject && (
                      <div className="plain-box m-2" style={{ cursor: "pointer" }} onClick={() => getSummaryReport(projectDetails.Summary_Reports__r?.records[0]?.id)}>
                        <div className="row">
                        <div className="col">
                          <p className="report-box-custmer-name">{projectDetails.Program__r?.name}</p>
                          <p className="report-box-project-name">{projectDetails?.Name}</p>
                          <p className="report-box-report-due"><b>Report Due:</b>  &nbsp;{summaryReportDueDate}</p>
                        <div className={`report-box-status-container`}> <div className={`report-box-status-pre ${!projectDetails.Summary_Reports__r?.records[0]?.Status__ || projectDetails.Summary_Reports__r?.records[0]?.Status__c === "Draft" ? reportStatusColor["Draft"] : reportStatusColor[projectDetails.Summary_Reports__r?.records[0]?.Status__c]}`}></div> <p className={`report-box-status`}><b>Under&nbsp;{ projectDetails.Summary_Reports__r?.records[0]?.Status__c}</b></p></div>
                        </div>
                        </div>
                      </div>
                    )}
                    {!isFMProject && projectDetails.Summary_Reports__r == null && (
                      <div className="dashed-box m-2" style={{ cursor: "pointer" }} onClick={() => handleSummaryReport()}>
                      <div className="row">
                        <div className="col text-center">
                          <div className="col text-center">
                            <i className="fas fa-plus icon"></i>
                            <p
                              className="p-0"
                              style={{ fontSize: "10px", fontWeight: "400" }}
                            >
                              CoC Report
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    )}
                    

                    {isFMProject && <div className="plain-box m-2" style={{ cursor: "pointer" }} onClick={handleFMReportCardClick}>
                      <div className="row">
                        <div className="col text-center">
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="0.0483398"
                              y="0.795898"
                              width="25"
                              height="25"
                              rx="3"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.0483 6.12939C9.36826 6.12939 6.38159 9.11606 6.38159 12.7961C6.38159 16.4761 9.36826 19.4627 13.0483 19.4627C16.7283 19.4627 19.7149 16.4761 19.7149 12.7961C19.7149 9.11606 16.7283 6.12939 13.0483 6.12939ZM13.7149 16.1294H12.3816V12.1294H13.7149V16.1294ZM13.7149 10.7961H12.3816V9.46273H13.7149V10.7961Z"
                              fill="#353535"
                            />
                          </svg>

                          <p
                            className="p-0"
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            Submit FM Audit report using the document upload
                            below
                          </p>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
              <br />
              <div className="card card-table p-4">
                <p className="p-0 m-0" style={{ fontSize: "16px" }}>
                  <strong>2. Document Upload</strong>
                </p>
                <span style={{ fontSize: "9px" }}>
                  Please upload any supporting documentation (checklist, etc)
                  from your field reporting.
                </span>

                <div className="card-body px-0 mt-2">
                  <div className="d-flex gap-3 align-items-center" ref={uploadSectionRef}>
                    <div>
                      <label>
                        Document Type<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>

                    <SelectField
                      label="Select"
                      data={getOptions(isFMProject ? fileUploadTypeOptions : fileUploadTypeOptions.filter(type => type !== "FM Summary Report"))}
                      selectedValue={fileUploadType}
                      onChange={(_, option) => setFileUploadType(option.value)}
                    />
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    <button
                      type="button"
                      className="btn btn-secondary bt-upload"
                      onClick={handleButtonClick}
                      style={{ fontSize: "10px" }}
                      disabled={!fileUploadType}
                    >
                      <img src={uploadIcon} alt="Upload Icon" className="save-icon" /> Upload File
                    </button>
                  </div>

                  <div
                    className="mt-3 project-doc2-upload-container"
                  >
                     {isDocSuccess &&
                <div className="project-upload-document-input">
                    <div className="doc-status-content">
                        <svg width="100" height="100">
                            <circle
                                fill="none"
                                stroke="#78A22F"
                                stroke-width="5"
                                cx="50"
                                cy="50"
                                r="45"
                                strokeLinecap="round"
                                transform="rotate(-40 50 50)"
                                className="doc-status-circle"
                            />
                            <polyline
                                fill="none"
                                stroke="#78A22F"
                                points="20,53 45,73 80,36"
                                strokeWidth="5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="doc-status-tick"
                            />
                        </svg>
                        <p className="doc-status-tick-text">Document Uploaded Successfully.</p>
                    </div>
                </div>
            }

            {isDocFail &&
                <div className="project-upload-document-input">
                    <div className="doc-status-content">
                        <svg width="100" height="100">
                            <circle
                                fill="none"
                                stroke="#C43131"
                                stroke-width="5"
                                cx="50"
                                cy="50"
                                r="45"
                                strokeLinecap="round"
                                transform="rotate(-40 50 50)"
                                className="doc-status-circle"
                            />
                            <path
                                fill="none"
                                stroke="#C43131"
                                stroke-width="6"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M 25,25 L 75,75 M 75,25 L 25,75"
                                className="doc-status-cross"
                            />
                        </svg>
                        <p className="doc-status-cross-text">Document Uploaded Failed, Please Try Again.</p>
                    </div>
                </div>
            }
                    <Row className="g-3">
                      {fileList.map((file, index) => (
                        <Col xs={12} md={6} xl={6} xxl={6} sm={12} key={index}>
                          <Card className="d-flex flex-row align-items-center p-2 justify-content-between uploadfile">
                            <div className="d-flex">
                              <img
                                src={UploadFileIcon}
                                alt="Upload"
                                className="me-2"
                              />
                              <div>
                                <p className="mb-0 file-name">{file.name}</p>
                                <small className="file-size">
                                  {file.size} {isNaN(Number(file.size)) ? '': 'kb'}
                                </small>
                              </div>
                            </div>
                            <div>
                              <span
                                onClick={() => fileRemove(file)}
                                className="cursor-pointer"
                              >
                                <img src={Closebtn} alt="Close" />
                              </span>
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-5">
           {/* <div className="project-submit-container">
              <p className="project-submit-text">Please ensure you tap ‘Submit’ to send your report on for formal review.</p>
              <Button className="project-submit-btn" onClick={handleSubmitProject}>Submit</Button>
            </div> */}
              <div className="card card-table p-10">
                {revertedCARs?.length > 0 && <><div className="row"><div className="d-flex gap-2 pb-2 align-items-top col car-attentions-section">
                  <RevisionRequired />
                  <strong>{revertedCARs.length}</strong>
                  <div>CAR requires your attention</div>
                </div> </div></>
                }
                <div className="row">
                  <div className="col-4">
                    <p className="d-flex p-0" style={{ fontSize: "16px" }}>
                      <strong>3.CARs</strong>
                    </p>
                  </div>
                  <div className="col-8">
                    <div className="form-check form-switch d-flex justify-content-end align-items-center">
                    <ToggleSwitch label={!isCarChecked ? "Hide Closed CARs:" : "Show All CARs:"} isCarChecked={isCarChecked} handleCarToggle={handleCarToggle} />
                    </div>
                  </div>
                </div>
                <p><b>{isCarChecked ? "Open CARs:" : "Total CARs:"}&nbsp;{CarDetails?.length || 0}</b></p>
                <div className="card-body px-0">
                  <div className="row d-flex justify-content-center">
                    <div
                      className="car-dashed-box m-2"
                        onClick={ projectStatus === STATUSES.DRAFT ? handleAddNewCar : undefined}
                        style={{
                          opacity:  projectStatus === STATUSES.DRAFT ? 1 : 0.5,
                          backgroundColor: '#e0e0e0',
                          padding: '20px',
                          cursor:  projectStatus === STATUSES.DRAFT ? 'pointer' : 'not-allowed',
                        }}
                    >
                      <div className="row">
                        <div className="col-1 d-flex justify-content-center align-items-center text-center">
                          <i className="fas fa-plus icon"></i>
                        </div>
                        <div className="col p-0 d-flex justify-content-center align-items-center text-center">
                          <span
                            className="p-0"
                            style={{ fontSize: "10px", fontWeight: "400" }}
                          >
                            Add New CAR
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="row d-flex justify-content-center project-cars-list">
                    {CarDetails ? ( 
                      CarDetails.map(
                      (car: any) => (
                        
                        <div
                          className="col-lg-12 col-md-12 col-sm-12 p-0 m-0"
                          key={car.Id}
                        >
                          <CarCard
                            action={car.Status__c}
                            revertedDraft={car.Reverted_Draft__c}
                            name={car.Name}
                            grade={car.Grade__c}
                            issueDate={car.CreatedDate}
                            dueDate={car.Due_Date__c}
                            onClick={() => handleCarClick(car)}
                            closedDate={car.Closed_Date__c}
                          />
                          <br />
                        </div>
                        
                      )
                    )) : (
                      <div className="car-empty-body"><p className="car-empty-body-text">No CARs Present.</p></div>
                    )}              
                </div>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>

      </main>
      <SummaryReport
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        projectId={projectId}
        reportId={reportId}
        reportformData={reportformData}
        section34Data={section34Data}
        folderPath={shareFileOpportunityFolderId}
        reportName={reportName}
      />
      <CarForm
        drawerOpen={drawerOpen}
        lookupdata={lookupData}
        carId={carId}
        folderPath={FolderId}
        scheme={projectDetails.Program__r?.id}
        projectId={projectId}
        grade={grade}
        setDrawerOpen={setDrawerOpen}
        onAddCar={handleAddCar}
        onDeleteCar={handleDeleteCar}
        handleAddOrCloseCARFrom={handleAddOrCloseCARFrom}
        carData={selectedCar}
        formType={formType}
        isloading={isLoading}
        certifiedSiteData={certifiedSiteData}
      />
      <FileUploadModal
        open={isFileUploadModalOpen}
        onClose={() => setIsFileUploadModalOpen(false)}
        onFileChange={setFileList}
      />
      {!!toster.show && <Toaster
        type={toster.type}
        show={toster.show}
        setShow={() => setToster({...toster, show: false})}
        message={toster.message}
      />}
      {/* delete Car Toster */}
      <Toaster
        type={deleteCARTosterInfo.type}
        show={showDeleteCARToster}
        setShow={setShowDeleteCARToster}
        message={deleteCARTosterInfo.message}
      />
      <CreateCARModel
         visible={isModalVisible}
         onHide={handleHideModal}
         onCarCreated={handleCreateCar} 
       />
       <ModalComponent 
        type="error" 
        title="Missing Requirement" 
        enableFooter={true} 
        btnText="Ok"
        show={showChecklistMissingModal}
        setShow={setChecklistMissingModal}
        onConfirmModal={handleChecklistSubmit}>
          <p>{showValidateSubmitProjectMsg}</p>
        </ModalComponent>

        <ModalComponent 
        type="plain" 
        title="Confirm Project Submission" 
        enableFooter={true} 
        btnText="Submit"
        show={showProjectSubmitConfirmModal}
        setShow={setProjectSubmitConfirmModal}
        onConfirmModal={handleProjectSubmitAfterConfirm}>
          <p>Please confirm that you have completed your Summary Report and have identified and reported all CARs.</p>
          <p className="fst-italic">Note: You will not be able to add additional CARs or update your Summary Report once you submit the project.</p>
        </ModalComponent>
    </>
  );
};

export default Projects;
